/**
 * Author: Wangyan
 * Date: 2018/10/22
 * Time: 14:40
 *
 */
// 车牌号验证，没有省份简称（包含新能源）
export function checkCarNum(str) {
  const oldReg = /[A-Z]{1}[A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳]{1}$/
  const neWReg = /[A-Z]{1}(([0-9]{5}[DF]$)|([DF][A-HJ-NP-Z0-9][0-9]{4}$))/
  if (oldReg.test(str)) {
    return true
  } else if (neWReg.test(str)) {
    return true
  } else {
    return false
  }
}

// 身份证验证(驾驶证相同)
export function checkPeopleId(str) {
  const reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
  return reg.test(str)
}

// 密码正则（必须包含大写字母和小写字母加数字，8到16位）
export function checkCipherRegular(str) {
  const reg = /^(?:(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])).{6,18}$/
  return reg.test(str)
}

// 新密码与确认密码匹配
export function checkCipherMatching(firstPwd, secondPwd) {
  if (firstPwd === secondPwd) {
    return true
  } else {
    return false
  }
}

// 手机号码验证
export function checkPhoneNum(str) {
  // const reg = /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/
  const reg = /^1[3456789]\d{9}$/
  return reg.test(str)
}

// 固话验证
export function checkTelephone(str) {
    const reg = /^0\d{2,3}-\d{7,8}(-\d{1,6})?$/
    return reg.test(str)
}

// 邮编号码验证
export function checkZipCode(str) {
  const reg = /^[0-9]{6}$/
  return reg.test(str)
}

// 中文字符以中文逗号分割验证
export function checkChinese(str) {
  const reg = /^([\u4e00-\u9fa5]+[，])*([\u4e00-\u9fa5]+)$/
  return reg.test(str)
}

// 车牌号码验证
export function checkCarNumber(str) {
  const reg = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{4}[A-Z0-9挂学警港澳]{1}$/
  return reg.test(str)
}

// 电子邮箱验证
export function checkEmail(str) {
  const reg = /^(\w)+(\.\w+)*@(\w)+((\.\w{2,3}){1,3})$/
  return reg.test(str)
}
